import { preferredPrinter } from './printer-preference';
import { printerRecentlyOnline } from './machine-view';

export const machinePrintUnresolved = (state?: string) => !!state && ['SENDING', 'UNKNOWN'].includes(state);
export const machinePrintPending = (state?: string) => !!state && ['QUEUED', 'LEASED', 'RECEIVED'].includes(state);
export function defaultMachinePrinter(printers: any[], userId?: string, area?: string, now = Date.now()) {
  const online = printers.filter(p => printerRecentlyOnline(p, now));
  const local = online.filter(p => area && p.location_name === area);
  return preferredPrinter(local.length ? local : online.length ? online : printers, userId);
}
export function machinePrintAction(job: any, printerId: string, permissions: { reprint: boolean; cancel: boolean }) {
  if (!job) return { allowed: true, label: 'In nhãn', replaceQueued: false };
  if (machinePrintUnresolved(job.state)) return { allowed: false, label: 'Cần kiểm tra yêu cầu cũ', replaceQueued: false };
  if (machinePrintPending(job.state)) return { allowed: permissions.reprint && permissions.cancel && printerId !== job.printerId,
    label: 'Hủy yêu cầu cũ và in tại máy đã chọn', replaceQueued: true };
  return { allowed: permissions.reprint, label: 'In lại tại máy đã chọn', replaceQueued: false };
}
